import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PoliticaCookiesComponent } from './politica-cookies/politica-cookies.component';
import { WorkflowGuard } from './workflow/workflow-guard.service';
import { AuthGuard } from './auth-1/auth.guard';
import { AuthService } from './shared/services/auth.service';
import { LoginComponent } from './auth/components/login/login.component';
import { AppComponent } from './app.component';
import { EditarDenunciaComponent } from './editar-denuncia/editar-denuncia.component';
import { EditarTodasDenunciasComponent } from './editar-todas-denuncias/editar-todas-denuncias.component';
import { EmailTokenGuard } from './auth-1/email-token.guard';
import { AdminComponent } from './admin/admin.component';
import { DeclaracionAccesibilidadComponent } from './declaracion-accesibilidad/declaracion-accesibilidad/declaracion-accesibilidad.component';
import { RecuperarPasswordComponent } from './auth/components/recuperar-password/recuperar-password.component';
import { PasswordTokenGuard } from './auth-1/password-token.guard';
import { RecuperarContraseniaDenunciaComponent } from './ver-denuncias/components/recuperar-contrasenia-denuncia/recuperar-contrasenia-denuncia.component';
import { PasswordTokenGuardComplaint } from './auth-1/password-token-complaint.guard';


const routes: Routes = [
  //MÓDULO DASHBOARD
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    children: [{
      path: '',
      loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
    }]
  },

  //MÓDULO VER DENUNCIA
  {
    path: 'ver-denuncia',
    children: [{
      path: '',
      loadChildren: () => import('./ver-denuncias/denuncias.module').then(m => m.DenunciasModule)
    }]
  },

  //MÓDULO ENVIAR DENUNCIA
  {
    path: 'enviar-denuncia',
    children: [{
      path: '',
      loadChildren: () => import('./enviar-denuncia/enviar-denuncia.module').then(m => m.EnviarDenunciaModule)
    }]
  },

  { path: 'admin', component: AdminComponent, canActivate: [EmailTokenGuard] },
  { path: 'login', component: LoginComponent, canActivate: [EmailTokenGuard] },
  { path: 'editar-denuncia/:id', component: EditarDenunciaComponent, canActivate: [AuthGuard] },
  { path: 'editar-todas-denuncias/:id', component: EditarTodasDenunciasComponent, canActivate: [AuthGuard] },
  { path: 'politica-cookies', component: PoliticaCookiesComponent },
  { path: 'inicio', component: AppComponent },
  { path: 'declaracion-de-accesibilidad', component: DeclaracionAccesibilidadComponent },
  { path: 'restablecer-contrasenia', component: RecuperarPasswordComponent, canActivate: [PasswordTokenGuard] },
  { path: 'restablecer-contrasenia-denuncia', component: RecuperarContraseniaDenunciaComponent, canActivate: [PasswordTokenGuardComplaint] },
  //{ path: 'validate-email', component: InitComponent },
  { path: '', redirectTo: '/', pathMatch: 'full' },

  // 6th Route
  { path: '**', component: LoginComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
  providers: [WorkflowGuard, AuthService, AuthGuard]
})
export class AppRoutingModule { }
